module.exports = __webpack_public_path__ + "img/03.51b5705.png";